<template>
  <div class="page-frame cooperation" v-if="pageData" role="main">
    <div class="container">
      <div v-if="pageData.acf && pageData.acf['header_image']" class="header-image" role="banner">
        <v-img
          v-bind:src="pageData.acf['header_image'].url"
          v-bind:alt="pageData.acf['header_image'].alt"
          aspect-ratio="3"
        ></v-img>
      </div>

      <section role="menubar" class="sections" v-if="tabs.length > 0">
        <ul>
          <li
            class="section"
            v-for="(tab, index) in tabs"
            v-bind:key="index"
            v-bind:class="{selected: index === selectedTab.index}"
            v-on:click="changeSection(tab.index)"
            role="tab"
          >
            <button v-bind:aria-label="tab.name">{{tab.name}}</button>
          </li>
        </ul>
      </section>

      <section role="tabpanel" class="section" v-if="selectedTab">
        <div v-html="selectedTab.content"></div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: "TabbedPage",
  props: {
    pageData: Object,
    contrastMode: Boolean
  },
  data: () => {
    return {
      tabs: [],
      selectedTab: null
    };
  },
  created() {
    this.parsePageData();
  },
  methods: {
    parsePageData() {
      if(this.pageData && this.pageData.acf && this.pageData.acf.tabs && this.pageData.acf.tabs.length > 0) {
        let tabs = [];
        this.pageData.acf.tabs.forEach( (tab, index) => {
          tabs.push({index, name: tab.tabTitle, content: tab.tabContent})
        });
        this.tabs = tabs;
        this.selectedTab = this.tabs[0];
      }
    },
    changeSection(index) {
      this.selectedTab = this.tabs[index];
    }
  }
};
</script>

<style lang="scss">
@import "../styles/_overrides.scss";
.cooperation {
  ul {
    list-style-type: none;
    padding: 0;
  }

  .sections {
    margin: 3rem 0;
    ul {
      display: flex;
    }
    li {
      margin-right: 2rem;
      button {
        padding: 10px 0;
      }
    }
    .selected {
      border-bottom: 2px solid #000;
      font-weight: bold;
    }
  }

  .project-link {
    text-decoration: none;
  }
}
</style>
